import { Exchange } from './order-exchange.interface';
import { Order } from './order.interface';
import { getNewPriceWithDiscounts } from './utils';

/**
 * An exchange can keep a fixed price only when its mother is a to-price order (no fixation indicators).
 * A to-fix mother has no price to replicate, so the mark does not apply.
 * @param mother Mother order of the exchange.
 * @returns boolean
 */
export function canExchangeHaveFixedPrice(mother: Order): boolean {
    return (mother?.price?.indicators?.length ?? 0) === 0;
}

/**
 * Returns a copy of the exchange with the fixed-price mark applied.
 * - To-fix mother: the mark is forced to false and the price is left untouched.
 * - Mark off: the price goes back to the mother price minus the agreed price discount, as the sync does.
 * - Mark on: the current exchange price is kept.
 * @param exchange Exchange to update.
 * @param mother Mother order of the exchange.
 * @param isFixedPrice Requested value of the mark.
 * @returns Exchange
 */
export function applyExchangeFixedPrice(exchange: Exchange, mother: Order, isFixedPrice: boolean): Exchange {
    if (!canExchangeHaveFixedPrice(mother)) {
        return { ...exchange, isFixedPrice: false };
    }

    if (isFixedPrice) {
        return { ...exchange, isFixedPrice: true };
    }

    const motherPrice = mother.price.price;
    return {
        ...exchange,
        isFixedPrice: false,
        price: motherPrice > 0 ? getNewPriceWithDiscounts(motherPrice, exchange.priceDiscount) : exchange.price,
    };
}
